import { useMemo } from 'react';
import { ROLE_NAMES } from '../../../util/const';
import useAuth from '../../../hooks/useAuth';

export const ROLES_FOR_COMMENT = [ROLE_NAMES.admin, ROLE_NAMES.super_admin, ROLE_NAMES.distributor];

const useRequestCommentCommon = ({ plan }) => {
    const auth = useAuth();
    const role = auth.user?.role;

    const isCommentReadOnly = useMemo(() => {
        if (!plan || !plan?.plan_id || !role || !ROLES_FOR_COMMENT.includes(role)) return true;
        return false;
    }, [plan, role]);

    const updatedByDisplay = useMemo(() => {
        if (!plan || !plan?.updated_by_first_name || !plan?.updated_by_last_name) return '';
        return `${plan?.updated_by_first_name}_${plan?.updated_by_last_name}`;
    }, [plan?.updated_by_first_name, plan?.updated_by_last_name]);

    return {
        isCommentReadOnly,
        updatedByDisplay,
    };
};

export default useRequestCommentCommon;
